import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Brand from 'models/brand';
import { Location } from 'models/locations';
import Booking from 'models/booking';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  booking: PropTypes.instanceOf(Booking),
  venueID: PropTypes.number,
};

const defaultProps = {
  venueID: null,
  booking: null,
};

class BookAgain extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.stopPropagation();
  }

  get type() {
    const { location, booking } = this.props;
    if (get(booking, 'isMonthly', false)) { return 'monthly'; }
    if (get(booking, 'airport', false) || location.airport) { return 'airport'; }
    return 'daily';
  }

  url() {
    const { location, venueID } = this.props;

    if (this.type === 'monthly') {
      return `${location.url}?monthly=1`;
    }

    if (this.type === 'airport') {
      return `${location.url}/?venue_id=${venueID}`;
    }

    return location.url;
  }

  render() {
    const { brand } = this.props;

    return (
      <a
        href={this.url()}
        className={`btn btn-block btn-primary ${brand.isBestParking ? 'btn-bp' : null}`}
        onClick={this.handleClick}
      >
        Book Here
      </a>
    );
  }
}

BookAgain.propTypes = propTypes;
BookAgain.defaultProps = defaultProps;
export default BookAgain;
